import PageSize from './pageSize';

export default PageSize;
